import Cookies from 'js-cookie'

const TokenKey = 'efarm-front-token';

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token,{ expires: 1 })
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}


export function getMember() {
    return Cookies.get('efarm-front-member')
}

export function setMember(member) {
    return Cookies.set('efarm-front-member', member,{ expires: 1 })
}


export function removeMember() {
    return Cookies.remove('efarm-front-member')
}
